// @ts-nocheck
import Api from 'api';
import React from "react";
import moment from 'moment';
import './_styles/index.scss';
import { connect } from 'react-redux';
import Cookies from 'universal-cookie';
import { Link } from 'react-router-dom';
import { actions, selectors } from 'redux-store';
import { Session as session } from 'components';

import Logo from './_nav_logo';
import Account from './_account';
import NavLink from './_nav_link';
import SearchBar from './_searchbar';
import AppLogo from "assets/app-logo.svg";

import Categories from './Dropdowns/_categories';
import AccountOptions from './Dropdowns/_accounts';


import {
  MdShoppingCart as CartIcon,
  MdLocalShipping as Shipping,
  MdShoppingBasket as Basket,
  MdLanguage as Language,
  MdSort as Category,
  MdRoom as Location
} from "react-icons/md";

import {
  FiMenu as Hamburger,
  FiX as CloseIcon
} from 'react-icons/fi';

// eslint-disable-next-line no-extend-native
Object.defineProperty(Array.prototype, 'empty', {
  value: function() { return (this.length === 0); }
});

// eslint-disable-next-line no-extend-native
Object.defineProperty(Array.prototype, 'remove', {
  value: function() {
    var what, a = arguments, L = a.length, ax;
    while (L && this.length) {
        what = a[--L];
        while ((ax = this.indexOf(what)) !== -1) {
            this.splice(ax, 1);
        }
    }
    return this;
  }
});

class Navigation extends React.Component {

  constructor(props) {

    super(props);

    this.api = new Api();

    this.cookies = new Cookies();

    this.state = {

      category_popup_x: 0,
      category_popup_visible: false,
      category_popup_ref: React.createRef(),

      accounts_popup_x: 0,
      accounts_popup_visible: false,
      accounts_popup_ref: React.createRef(),

      show_menu_items: false,

      auth: {},

    }

  }

  componentDidMount = () => {

    document.addEventListener('mousemove', this.handleHover, false);

    const category_bounds = this.category_button.getBoundingClientRect();

    const accounts_bounds = this.accounts_button.getBoundingClientRect();

    return this.setState({
      category_popup_x: category_bounds.left,
      accounts_popup_x: accounts_bounds,
      show_menu_items: this.props.expand
    }, () => this.fetch_api_data());

  }

  handleHover = (e) => {

    this.handle_accounts_hover(e);

    this.handle_category_hover(e);

  }

  handle_category_hover = (e) => {

    if (!this.category_button) return;

    if (!this.category_popup_ref) return;

    const list_hover = this.category_button.contains(e.target);

    const button_hover = this.category_popup_ref.contains(e.target);

    const show_category_list = (!!button_hover || !!list_hover);

    if (show_category_list === this.state.category_popup_visible) return;

    return this.setState({ category_popup_visible: show_category_list });

  }

  handle_accounts_hover = (e) => {

    if (!this.accounts_button) return;

    if (!this.accounts_popup_ref) return;

    const list_hover = this.accounts_button.contains(e.target);

    const button_hover = this.accounts_popup_ref.contains(e.target);

    const show_category_list = (!!button_hover || !!list_hover);

    if (show_category_list === this.state.accounts_popup_visible) return;

    return this.setState({ accounts_popup_visible: show_category_list });

  }

  handleClick = () => {

    const { category_popup_visible } = this.state;

    if (!category_popup_visible) {
      document.addEventListener('click', this.handleOutsideClick, false);
    } else {
      document.removeEventListener('click', this.handleOutsideClick, false);
    }

    return this.setState({ category_popup_visible: !category_popup_visible });

  }

  handleOutsideClick = (e) => {

    if (!this.category_button) return;

    if (this.category_button.contains(e.target)) return;

    return this.handleClick();

  }

  toggleMenu = () => {

    const { show_menu_items } = this.state;

    return this.setState({ show_menu_items: !show_menu_items });

  }

  fetch_api_data = () => {
    this.session_start();
    this.fetch_categories()
  }

  fetch_categories = async () => {

    if (!this.props.categories.empty()) return;

    const { docs = [] } = await this.api.fetch('categories','all','');

    const categories = docs.map(snapshot => snapshot.data());

    return this.props.update_categories(categories);

  }

  fetch_cart_data = async () => {

    const { auth } = this.state;

    if (!this.state.auth.fid) return;

    if (!this.props.cart.empty()) return;

    const response = await this.api.fetch_cart(auth.fid);

    const user = (!response.exists) ? null : response.data();

    return (!user) ? null : this.props.update_cart(user.cart);

  }

  session_start = async () => {

    let session_data = this.cookies.get('session_data');

    if (!session_data) await this.start_user_session();

    session_data = this.cookies.get('session_data');

    await this.update_session_data(session_data);

  }

  update_session_data = async (session) => {

    const { last_login } = session;

    const date_today = moment().format('DD-MM-YYY');

    if (!last_login)  session.last_login = moment().format();

    const session_date = moment(session.last_login).format('DD-MM-YYY');

    const update_data = (!last_login || (date_today !== session_date));

    if (!!update_data) session.last_login = moment().format();

    if (!!update_data) await this.api.update_session(session);

    if (!!update_data) this.cookies.set('session_data', session, { path:'/' });

    return this.setState({ auth: session }, () => this.fetch_cart_data());

  }

  session_end = async () => {

    const session = this.cookies.get('session_data');

    const new_session = {...session, logged_out: true };

    this.cookies.set('session_data', new_session, { path:'/' });

    await this.api.update_session(new_session);

    return this.setState({ auth: new_session }, () => window.location.reload());

  }

  start_user_session = async () => {

    const client_id = session.guid();

    const client_data = session.data(client_id);

    const { id } = await this.api.log_session(client_data);

    return this.cookies.set('session_data', {...client_data,fid:id}, { path:'/' });

  }

  render() {

    const { show_menu_items } = this.state;

    const hidden = `${!show_menu_items ? 'hidden' : ''}`;

    const MenuIcon = (!!show_menu_items) ? CloseIcon : Hamburger;

    return (
      <div className={`Nav-Placeholder ${hidden}`}>
      <section className='Navigation'>

        <div className="Nav-Banner">
          <div className="Nav-Wrapper">

            <div className="Nav-Feed">
              Free Shipping Within Nairobi
            </div>

            <div className="Nav-Links">
              <NavLink Icon={Basket} label='Re-Order' hidden/>
              <NavLink Icon={Shipping} label='Track Order' hidden/>
              <NavLink Icon={Location} label='Our Location'/>
              <NavLink Icon={Language} label='EN'/>
            </div>

          </div>
        </div>

        <div className="Main-Nav-Bar">
          <div className="Nav-Wrapper">

            <div className="Menu-Button" onClick={() => this.toggleMenu()}>
              <MenuIcon/>
            </div>

            <Logo image={{ backgroundImage: `url(${AppLogo})` }}/>

            <div
              ref={a => (this.category_button = a)}
              className="Nav-Categories"
              onClick={this.handleClick}>
              <Category className='Nav-Icon'/>
              <div className="Nav-Button-Label">Categories</div>
            </div>

            <Categories
              hidden={hidden}
              data={this.props.categories}
              left={this.state.category_popup_x}
              visible={this.state.category_popup_visible}
              popup_ref={el => (this.category_popup_ref = el)}
            />

            <AccountOptions
              session={this.state.auth}
              onEndSession={this.session_end}
              bounds={this.state.accounts_popup_x}
              visible={this.state.accounts_popup_visible}
              popup_ref={el => (this.accounts_popup_ref = el)}
            />

            <SearchBar  hidden={hidden}/>

            <Link to='/cart' className="Nav-Cart-Button">
              <div className="Cart-Icon-Wrap">
                <CartIcon className='Cart-Icon'/>
                <div className="Cart-Item-Count">{this.props.count}</div>
              </div>
              <div className="Nav-Button-Label">Cart</div>
            </Link>

            <Account
              session={this.state.auth}
              btn_ref={a => (this.accounts_button = a )}
            />

          </div>
        </div>

      </section>
      </div>
    );
  }
}

const mapStateToProps = ({ cart, cache }) => ({
  ...cache,
  cart: cart.cart_items,
  count: selectors.cart_count(cart)
});

export default connect(mapStateToProps, { ...actions })(Navigation);
